import axios from 'axios'

export default {
    namespaced: true,
    state: {
        loadingNotes: false,
        notes: []
    },
    mutations: {
        SET_LOADING_NOTES(state, loading) {
            state.loadingNotes = loading;
        },
        SET_NOTES(state, notes) {
            state.notes = notes;
        },
        CREATE_NOTE(state, note) {
            state.notes.push(note);
        },
        DELETE_NOTE(state, note_id) {
            const deleteIndex = state.notes.findIndex(note => note.id === note_id);

            state.notes.splice(deleteIndex, 1);
        }
    },
    getters: {
        notes(state) {
            return state.notes;
        }
    },
    actions: {
        loadNotes({ commit }, lead_id) {
            commit("SET_LOADING_NOTES", true);

            axios.get(`/notes/${lead_id}`)
                .then(res => {
                    commit("SET_NOTES", res.data.notes);
                    commit("SET_LOADING_NOTES", false);
                })
                .catch(e => {
                    console.log(e)
                    commit("SET_LOADING_NOTES", false);
                })
        },
        createNote({ commit, rootState }, message) {
            axios.post('/notes/create', {
                user_id: rootState.auth.user.id,
                lead_id: rootState.lead.lead.id,
                message,
            }).then(res => {
                commit("CREATE_NOTE", res.data.note);
            }).catch(err => {
                console.log(err);
            });
        },
        deleteNote({ commit }, note_id) {
            axios.delete(`/notes/${note_id}`)
                .then(() => {
                    commit("DELETE_NOTE", note_id);
                }).catch(err => {
                    console.log(err);
                });
        }
    },
}